import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import * as moment from 'moment-jalaali';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor() {}

  public nowPersianDate(): string {
    const m = moment();
    m.locale('fa');
    return m.format('jYYYY/jM/jD');
  }

  public nowPersianDate2(): string {
    const m = moment();
    return m.format('jYYYYjMjD');
  }

  public nowPersianTime(): string {
    const m = moment();
    return m.format('HH:mm:ss');
  }

  public persianDateTime(date): string {
    if (date) {
      const m = moment(date);
      m.locale('fa');
      return m.format('jYYYY/jM/jD-HH:mm:ss');
    } else {
      return '';
    }
  }

  public persianDate(date): string {
    if (date) {
      const m = moment(date);
      m.locale('fa');
      return m.format('jYYYY/jM/jD');
    } else {
      return '';
    }
  }

  public getElapsedTime(input): string {
    const date = new Date(input);
    const now = new Date();
    // Compute time difference in milliseconds let
    const diff = now.getTime() - date.getTime();
    // Convert time difference from milliseconds to seconds
    const seconds = Math.abs(diff / 1000);
    // Extract integer seconds that do not form a minute using %
    // let seconds = Math.floor(diff % 60);

    if (seconds < 60) {
      return 'just now';
    } else if (seconds < 60 * 60) {
      return Math.floor(seconds / 60) + ' Minutes ago';
    } else if (seconds < 60 * 60 * 24) {
      return Math.floor(seconds / (60 * 60)) + ' Hours ago';
    }
    // else if (seconds < 60*60 * 24 * 7) {

    //     return Math.floor(seconds / (60 * 60 * 24)) + " Days ago";
    // }
    else {
      const format =
        [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('/') +
        ' ' +
        [date.getHours(), date.getMinutes(), date.getSeconds()].join(':');
      return format;
    }
  }
  public getElapsedTimeV2(input): string {
    const date = new Date(input);
    const now = new Date();
    // Compute time difference in millisecondslet
    const diff = now.getTime() - date.getTime();
    // Convert time difference from milliseconds to seconds
    const seconds = Math.abs(diff / 1000);
    // Extract integer seconds that do not form a minute using %
    // let seconds = Math.floor(diff % 60);

    if (seconds < 60) {
      return 'just now';
    } else if (seconds < 60 * 60) {
      return Math.floor(seconds / 60) + ' Minutes ago';
    } else if (seconds < 60 * 60 * 24) {
      return Math.floor(seconds / (60 * 60)) + ' Hours ago';
    } else if (seconds < 60 * 60 * 24 * 7) {
      return Math.floor(seconds / (60 * 60 * 24)) + ' Days ago';
    } else {
      const format = [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('/');
      return format;
    }
  }
  monthText(monthIndex: number): string {
    const monthNames: string[] = [
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند',
    ];
    return monthNames[monthIndex];
  }
  weekText(weekIndex): string {
    const weekDayNames: string[] = [
      'شنبه',
      'یک شنبه',
      'دوشنبه',
      'سه شنبه',
      'چهارشنبه',
      'پنج شنبه',
      'جمعه',
    ];

    return weekDayNames[weekIndex];
  }
}
